import type { Frame, PropValue } from './types';
import { defaultsFrom } from './props-schema';

export type TsxResolved =
  | { tsx: string; props: Record<string, PropValue> }
  | { error: string };

/** Resolve any tsx* frame to the module source + props to render with. */
export function resolveTsxRender(frame: Frame, byId: Map<string, Frame>): TsxResolved {
  if (frame.kind === 'tsxFree') return { tsx: frame.tsx, props: {} };
  if (frame.kind === 'tsxMain') return { tsx: frame.tsx, props: defaultsFrom(frame.propsSchema) };
  if (frame.kind === 'tsxInstance') {
    const main = byId.get(frame.mainId);
    if (!main || main.kind !== 'tsxMain') return { error: `missing Main: ${frame.mainId}` };
    return { tsx: main.tsx, props: { ...defaultsFrom(main.propsSchema), ...frame.propValues } };
  }
  return { error: 'not a tsx frame' };
}
